import { render } from "./TabletDevices.vue?vue&type=template&id=dbf4d79e"
import script from "./TabletDevices.vue?vue&type=script&lang=js"
export * from "./TabletDevices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__